import { useEffect, useRef } from "react";
import {
  FiArrowRight,
  FiBookOpen,
  FiCalendar,
  FiCheck,
  FiCheckCircle,
  FiCreditCard,
  FiFileText,
  FiGlobe,
  FiGrid,
  FiPackage,
  FiPlayCircle,
  FiRepeat,
  FiShield,
  FiSmartphone,
  FiTruck,
  FiTv,
  FiUserCheck,
  FiUsers,
  FiWifi,
  FiZap,
} from "react-icons/fi";

import "../styles/MalaysiaProduct.css";

const REGISTER_URL = "https://etikaf.com/daftar";
const LOGIN_URL = "https://admin.etikaf.com";

const HERO_SOURCES = [
  { src: "/assets/etv_demo.webm", type: "video/webm" },
  { src: "/assets/etv_demo.mp4", type: "video/mp4" },
];

const includedItems = [
  {
    icon: FiTv,
    title: "Peranti Etikaf TV",
    text: "Peranti khas yang disambungkan kepada TV masjid untuk menjalankan paparan Etikaf secara automatik.",
  },
  {
    icon: FiGrid,
    title: "Sistem Admin Etikaf",
    text: "Urus kuliah, poster, video, pengumuman, profil masjid dan tetapan ETV dari telefon atau komputer.",
  },
  {
    icon: FiGlobe,
    title: "Halaman & QR masjid",
    text: "Jemaah boleh mengakses waktu solat, aktiviti, pegawai, lokasi dan maklumat masjid melalui pautan atau QR.",
  },
  {
    icon: FiSmartphone,
    title: "Aplikasi Etikaf — percuma",
    text: "Jemaah boleh menggunakan aplikasi mudah alih Etikaf secara percuma untuk mengikuti maklumat masjid.",
  },
  {
    icon: FiCalendar,
    title: "Pengurusan kuliah",
    text: "Susun jadual, asatizah, kitab dan aktiviti berulang tanpa memasukkan maklumat yang sama berkali-kali.",
  },
  {
    icon: FiShield,
    title: "Waranti 12 bulan",
    text: "Peranti Etikaf TV dilindungi waranti selama 12 bulan dan dihantar melalui pos.",
  },
];

const displayFeatures = [
  "Waktu solat dan kira detik",
  "Jadual kuliah dan aktiviti",
  "Poster, video dan infografik",
  "Pengumuman segera",
  "Ayat al-Quran dan pengisian",
  "Siaran langsung dari Mekah",
  "Paparan gelap ketika solat",
  "Kandungan yang dikawal dari jauh",
];

const faqGroups = [
  {
    title: "Tentang Etikaf",
    items: [
      {
        q: "Apa itu Etikaf?",
        a: "Etikaf ialah pakej digital lengkap untuk masjid dan surau. Pihak masjid mengurus maklumat melalui Sistem Admin, kemudian maklumat yang sama boleh disampaikan melalui Etikaf TV, halaman masjid dan aplikasi Etikaf untuk jemaah.",
      },
      {
        q: "Apa beza Etikaf dengan Etikaf TV (ETV)?",
        a: "Etikaf ialah keseluruhan sistem. Etikaf TV ialah peranti dalam pakej Etikaf yang menjalankan paparan pada TV masjid. ETV menggunakan kandungan yang diurus melalui Sistem Admin Etikaf.",
      },
      {
        q: "Boleh beli ETV atau Sistem Admin secara berasingan?",
        a: "Tidak. Pakej Etikaf untuk Malaysia merangkumi peranti Etikaf TV bersama langganan Sistem Admin. Kedua-duanya berfungsi sebagai satu sistem.",
      },
      {
        q: "Siapa yang sesuai menggunakan Etikaf?",
        a: "Etikaf sesuai untuk masjid, surau, musolla, pusat komuniti Islam dan institusi yang mahu mengurus serta memaparkan maklumat secara lebih tersusun.",
      },
    ],
  },
  {
    title: "Peranti & penggunaan",
    items: [
      {
        q: "Adakah TV disertakan?",
        a: "Tidak. Harga pakej merangkumi peranti Etikaf TV sahaja. Pihak masjid menggunakan TV sedia ada.",
      },
      {
        q: "Bagaimana pemasangan dibuat?",
        a: "Peranti dihantar melalui pos dan direka untuk pemasangan secara plug and play. Panduan sambungan akan diberikan bersama peranti.",
      },
      {
        q: "Adakah sambungan internet diperlukan?",
        a: "Ya. Internet diperlukan supaya peranti menerima waktu solat, kuliah, poster, video, pengumuman dan perubahan kandungan daripada Sistem Admin.",
      },
      {
        q: "Boleh kandungan dikawal menggunakan telefon?",
        a: "Boleh. Sistem Admin Etikaf boleh digunakan melalui telefon atau komputer untuk mengurus kandungan dari jauh.",
      },
      {
        q: "Siapa yang menyediakan kandungan ETV?",
        a: "Pihak masjid boleh memasukkan kandungan sendiri melalui Sistem Admin. Etikaf turut membantu menyusun paparan automatik seperti waktu solat dan fungsi sistem yang tersedia.",
      },
    ],
  },
  {
    title: "Sistem Admin & halaman masjid",
    items: [
      {
        q: "Boleh jana takwim kuliah untuk dicetak?",
        a: "Boleh. Jadual kuliah yang dimasukkan ke dalam Sistem Admin boleh dijana sebagai PDF Takwim A4 untuk dicetak atau dikongsi kepada jemaah.",
      },
      {
        q: "Apakah maklumat yang jemaah lihat selepas mengimbas QR masjid?",
        a: "QR membawa jemaah ke halaman mini masjid yang memaparkan waktu solat, kuliah, aktiviti, pegawai, lokasi, poster dan hebahan semasa.",
      },
      {
        q: "Adakah masjid perlu mempunyai website sendiri?",
        a: "Tidak. Setiap masjid mendapat halaman mini Etikaf yang boleh dibuka melalui pautan atau QR tanpa perlu membina website berasingan.",
      },
      {
        q: "Boleh jadualkan kuliah mingguan atau bulanan?",
        a: "Boleh. Kuliah dan aktiviti berulang boleh disusun mengikut jadual supaya pihak masjid tidak perlu memasukkan maklumat yang sama berkali-kali.",
      },
      {
        q: "Bagaimana maklumat Asatizah dan Kitab digunakan?",
        a: "Profil Asatizah dan Kitab boleh disimpan dalam Sistem Admin, kemudian dipadankan dengan jadual kuliah untuk paparan yang lebih tersusun di ETV, halaman masjid dan aplikasi.",
      },
      {
        q: "Boleh kemas kini profil dan pegawai masjid?",
        a: "Boleh. Profil masjid, lokasi, maklumat perhubungan dan senarai pegawai boleh dikemas kini melalui Sistem Admin.",
      },
    ],
  },
  {
    title: "Harga, pendaftaran & penghantaran",
    items: [
      {
        q: "Berapa jumlah tahun pertama?",
        a: "Pakej tahun pertama ialah RM3,600: RM3,000 untuk peranti Etikaf TV dan RM600 untuk langganan Sistem Etikaf selama setahun. Dengan penghantaran, jumlah bayaran ialah RM3,625 ke Semenanjung atau RM3,650 ke Sabah, Sarawak dan Labuan.",
      },
      {
        q: "Adakah RM3,000 perlu dibayar setiap tahun?",
        a: "Tidak. RM3,000 ialah bayaran sekali untuk peranti. Pembaharuan tahun berikutnya hanya RM600 setahun untuk meneruskan penggunaan Sistem Admin dan perkhidmatan Etikaf.",
      },
      {
        q: "Bagaimana bayaran dibuat sekarang?",
        a: "Daftar melalui satu borang, sahkan e-mel, masukkan maklumat pegawai dan alamat penghantaran, kemudian bayar keseluruhan pakej melalui Billplz. Sistem Admin dan pesanan peranti ETV direkodkan bersama.",
      },
      {
        q: "Adakah kos penghantaran termasuk dalam RM3,600?",
        a: "Tidak. Caj tetap ialah RM25 untuk Semenanjung Malaysia dan RM50 untuk Sabah, Sarawak serta Labuan. Caj dipaparkan dan dimasukkan terus dalam jumlah bayaran sebelum anda membayar.",
      },
      {
        q: "Bagaimana peranti dihantar?",
        a: "Peranti Etikaf TV dihantar melalui pos selepas bayaran peranti disahkan.",
      },
      {
        q: "Berapa lama tempoh waranti?",
        a: "Peranti Etikaf TV mempunyai waranti selama 12 bulan.",
      },
    ],
  },
  {
    title: "Aplikasi jemaah",
    items: [
      {
        q: "Adakah aplikasi Etikaf percuma untuk jemaah?",
        a: "Ya. Aplikasi Etikaf untuk jemaah boleh digunakan secara percuma.",
      },
      {
        q: "Perlu masukkan maklumat semula ke dalam aplikasi?",
        a: "Tidak. Pihak masjid mengurus maklumat melalui Sistem Admin dan maklumat tersebut digunakan dalam ekosistem Etikaf tanpa perlu dimasukkan berulang kali.",
      },
      {
        q: "Apa beza aplikasi Etikaf dengan Sistem Admin?",
        a: "Sistem Admin digunakan oleh pihak masjid untuk mengurus maklumat. Aplikasi Etikaf digunakan oleh jemaah untuk melihat maklumat masjid, waktu solat, kuliah dan aktiviti.",
      },
    ],
  },
];

function LazyDemoVideo() {
  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return undefined;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry?.isIntersecting) return;
        video.querySelectorAll("source").forEach((source) => {
          if (source.dataset.src) source.src = source.dataset.src;
        });
        video.load();
        video.play().catch(() => { });
        observer.disconnect();
      },
      { rootMargin: "240px" }
    );

    observer.observe(video);
    return () => observer.disconnect();
  }, []);

  return (
    <video
      ref={videoRef}
      className="my-demo-video"
      poster="/assets/pengenalan/etv-screen-2.png"
      muted
      loop
      playsInline
      controls
      preload="none"
      aria-label="Demo paparan Etikaf TV"
    >
      {HERO_SOURCES.map((source) => (
        <source key={source.type} data-src={source.src} type={source.type} />
      ))}
    </video>
  );
}

function SectionHeading({ eyebrow, title, description, align = "left" }) {
  return (
    <div className={`my-section-heading my-align-${align}`}>
      <div className="my-eyebrow">{eyebrow}</div>
      <h2>{title}</h2>
      {description ? <p>{description}</p> : null}
    </div>
  );
}

export default function MalaysiaProduct() {
  useEffect(() => {
    const previousTitle = document.title;
    const description = document.querySelector('meta[name="description"]');
    const previousDescription = description?.getAttribute("content") || "";
    const canonical = document.querySelector('link[rel="canonical"]');
    const previousCanonical = canonical?.getAttribute("href") || "";

    document.title = "Etikaf untuk Masjid — Sistem Digital & ETV";
    description?.setAttribute(
      "content",
      "Daftar Etikaf untuk masjid dan surau di Malaysia: peranti Etikaf TV, Sistem Admin, halaman masjid dan aplikasi jemaah dalam satu ekosistem digital."
    );
    canonical?.setAttribute("href", "https://etikaf.com/my");

    return () => {
      document.title = previousTitle;
      description?.setAttribute("content", previousDescription);
      canonical?.setAttribute("href", previousCanonical);
    };
  }, []);

  return (
    <div className="my-page" id="top">
      <header className="my-hero">
        <div className="my-shell my-hero-grid">
          <div className="my-hero-copy">
            <h1>Urus sekali. Paparkan di TV. Sampaikan kepada jemaah.</h1>
            <p className="my-hero-lead">
              Etikaf menghubungkan <strong>Sistem Admin</strong>, <strong>Etikaf TV</strong>,
              halaman masjid dan <strong>aplikasi mudah alih</strong> dalam satu ekosistem yang
              mudah diurus dari telefon atau komputer.
            </p>

            <div className="my-hero-actions">
              <a className="my-button my-button-primary" href={REGISTER_URL}>
                Daftar Etikaf <FiArrowRight />
              </a>
              <a className="my-button my-button-secondary" href="#demo">
                <FiPlayCircle /> Lihat demo
              </a>
            </div>

            <div className="my-price-brief" aria-label="Ringkasan harga">
              <div>
                <span>Tahun pertama</span>
                <strong>RM3,600</strong>
                <small>+ penghantaran RM25 / RM50</small>
              </div>
              <div className="my-price-divider" />
              <div>
                <span>Tahun berikutnya</span>
                <strong>RM600</strong>
                <small>setahun sahaja</small>
              </div>
            </div>

            <p className="my-hero-note">
              <FiCheckCircle /> Peranti ETV, Sistem Admin setahun, aplikasi jemaah percuma dan waranti 12 bulan.
            </p>
          </div>

          <div className="my-hero-visual" aria-label="Contoh ekosistem Etikaf">
            <div className="my-visual-window">
              <div className="my-window-bar"><i /><i /><i /></div>
              <img
                src="/assets/pengenalan/etv-screen.png"
                alt="Contoh paparan Etikaf TV di masjid"
              />
            </div>
            <div className="my-floating-card my-floating-admin">
              <FiGrid />
              <div><strong>Urus dari jauh</strong><span>Telefon atau komputer</span></div>
            </div>
            <div className="my-floating-card my-floating-app">
              <FiSmartphone />
              <div><strong>Sampai kepada jemaah</strong><span>Web dan aplikasi</span></div>
            </div>
          </div>
        </div>
      </header>

      <main>
        <section className="my-trust-strip">
          <div className="my-shell my-trust-grid">
            <div><FiZap /><span><strong>Plug and play</strong>Peranti dihantar melalui pos</span></div>
            <div><FiWifi /><span><strong>Kawalan dari jauh</strong>Kemas kini melalui internet</span></div>
            <div><FiShield /><span><strong>Waranti 12 bulan</strong>Untuk peranti Etikaf TV</span></div>
            <div><FiSmartphone /><span><strong>Aplikasi jemaah</strong>Percuma digunakan</span></div>
          </div>
        </section>

        <section className="my-section my-shell" id="cara">
          <SectionHeading
            eyebrow="Satu ekosistem"
            title="Masukkan maklumat sekali, sampaikan di banyak tempat."
            description="Pihak masjid tidak perlu mengurus TV, laman masjid dan aplikasi secara berasingan. Maklumat bermula daripada Sistem Admin dan digunakan dalam ekosistem yang sama."
            align="center"
          />

          <div className="my-flow" aria-label="Aliran ekosistem Etikaf">
            <div className="my-flow-source">
              <div className="my-flow-icon"><FiGrid /></div>
              <span>Pihak masjid mengurus</span>
              <strong>Sistem Admin</strong>
              <small>Kuliah, poster, video, profil dan pengumuman</small>
            </div>
            <div className="my-flow-arrow"><FiArrowRight /></div>
            <div className="my-flow-destinations">
              <div><FiTv /><span><strong>Etikaf TV</strong>Paparan di masjid</span></div>
              <div><FiGlobe /><span><strong>Halaman masjid</strong>Akses melalui pautan & QR</span></div>
              <div><FiSmartphone /><span><strong>Aplikasi Etikaf</strong>Maklumat di tangan jemaah</span></div>
            </div>
          </div>
        </section>

        <section className="my-section my-problem-section">
          <div className="my-shell my-problem-grid">
            <div>
              <SectionHeading
                eyebrow="Kenapa Etikaf"
                title="Maklumat masjid lebih mudah diurus dan lebih cepat sampai."
                description="Etikaf menggantikan kerja berulang dengan satu aliran yang lebih tersusun."
              />
              <div className="my-problem-list">
                <div><span>01</span><p>Tak perlu hadir ke masjid hanya untuk menukar paparan TV.</p></div>
                <div><span>02</span><p>Tak perlu menyimpan dan menukar poster menggunakan pendrive.</p></div>
                <div><span>03</span><p>Jadual kuliah, asatizah dan kitab tersusun dalam satu tempat.</p></div>
                <div><span>04</span><p>Jemaah mendapat maklumat yang sama melalui TV, web dan aplikasi.</p></div>
              </div>
            </div>
            <div className="my-admin-preview">
              <div className="my-preview-label">Sistem Admin Etikaf</div>
              <img
                src="/assets/pengenalan/admin-sample.png"
                alt="Paparan Sistem Admin Etikaf"
              />
              <div className="my-admin-caption">
                <FiCheckCircle /> Boleh digunakan melalui telefon atau komputer
              </div>
            </div>
          </div>
        </section>

        <section className="my-section my-shell" id="pakej">
          <SectionHeading
            eyebrow="Apa yang anda dapat"
            title="Satu pakej lengkap untuk masjid."
            description="ETV dan Sistem Admin tidak dijual sebagai dua produk berasingan. Kedua-duanya ialah sebahagian daripada satu pakej Etikaf."
            align="center"
          />
          <div className="my-included-grid">
            {includedItems.map(({ icon: Icon, title, text }) => (
              <article className="my-included-card" key={title}>
                <div className="my-card-icon"><Icon /></div>
                <h3>{title}</h3>
                <p>{text}</p>
              </article>
            ))}
          </div>
        </section>

        <section className="my-section my-admin-tools-section">
          <div className="my-shell">
            <SectionHeading
              eyebrow="Lebih daripada paparan TV"
              title="Sistem yang turut memudahkan kerja pengurusan masjid."
              description="Etikaf bukan sekadar peranti pada TV. Sistem Admin membantu pihak masjid menyusun maklumat, menjana bahan dan memberi jemaah akses yang lebih mudah."
              align="center"
            />

            <div className="my-tool-showcases">
              <article className="my-tool-showcase">
                <div className="my-tool-copy">
                  <span><FiFileText /> Takwim untuk cetakan</span>
                  <h3>Jana PDF Takwim A4 secara automatik.</h3>
                  <p>
                    Jadual kuliah yang telah dimasukkan boleh terus dijadikan takwim A4 untuk
                    dicetak, ditampal atau dikongsi tanpa menyusun semula kandungan.
                  </p>
                  <ul>
                    <li><FiCheck /> Menggunakan jadual daripada Sistem Admin</li>
                    <li><FiCheck /> Sesuai untuk cetakan dan perkongsian digital</li>
                    <li><FiCheck /> Kurangkan kerja reka bentuk yang berulang</li>
                  </ul>
                </div>
                <div className="my-tool-media my-tool-media-document">
                  <img src="/assets/pengenalan/pdf-sample.png" alt="Contoh PDF Takwim A4 Etikaf" />
                </div>
              </article>

              <article className="my-tool-showcase my-tool-showcase-reverse">
                <div className="my-tool-copy">
                  <span><FiGlobe /> Halaman mini masjid</span>
                  <h3>QR terus ke halaman mini masjid.</h3>
                  <p>
                    Setiap masjid boleh berkongsi satu QR untuk membawa jemaah kepada maklumat
                    terkini tanpa perlu mempunyai website sendiri.
                  </p>
                  <ul>
                    <li><FiCheck /> Waktu solat, kuliah dan aktiviti</li>
                    <li><FiCheck /> Profil, pegawai, lokasi dan perhubungan</li>
                    <li><FiCheck /> Poster, hebahan dan kempen semasa</li>
                  </ul>
                </div>
                <div className="my-tool-media my-tool-media-qr">
                  <img src="/assets/pengenalan/qr-sample.png" alt="Contoh QR dan halaman mini masjid" />
                </div>
              </article>
            </div>

            <div className="my-admin-benefits">
              <article><FiRepeat /><span><strong>Kuliah berulang</strong>Susun jadual mingguan atau bulanan.</span></article>
              <article><FiBookOpen /><span><strong>Asatizah &amp; Kitab</strong>Padankan maklumat dengan jadual kuliah.</span></article>
              <article><FiUserCheck /><span><strong>Profil pengurusan</strong>Kemas kini profil dan pegawai masjid.</span></article>
              <article><FiFileText /><span><strong>Kempen &amp; hebahan</strong>Sampaikan maklumat dalam ekosistem yang sama.</span></article>
            </div>
          </div>
        </section>

        <section className="my-section my-app-section">
          <div className="my-shell my-app-grid">
            <div className="my-app-copy">
              <SectionHeading
                eyebrow="Untuk jemaah"
                title="Maklumat masjid sentiasa dekat melalui aplikasi Etikaf."
                description="Jemaah boleh melihat waktu solat, kuliah, aktiviti, lokasi dan maklumat masjid. Aplikasi Etikaf boleh digunakan secara percuma."
              />
              <ul className="my-check-list">
                <li><FiCheck /> Semak kuliah dan aktiviti masjid</li>
                <li><FiCheck /> Lihat waktu solat dan kira detik</li>
                <li><FiCheck /> Capai lokasi dan maklumat masjid</li>
                <li><FiCheck /> Lihat poster dan hebahan terkini</li>
              </ul>
              <div className="my-store-row" aria-label="Aplikasi Etikaf tersedia untuk telefon pintar">
                <img src="/assets/apple.png" alt="Tersedia di App Store" />
                <img src="/assets/google.png" alt="Tersedia di Google Play" />
              </div>
              <p className="my-store-note">Aplikasi jemaah adalah percuma. Sistem Admin digunakan oleh pihak masjid.</p>
            </div>
            <div className="my-phone-stage">
              <div className="my-phone-card">
                <img src="/assets/app_etikaf_home.png" alt="Paparan halaman utama aplikasi Etikaf" />
              </div>
            </div>
          </div>
        </section>

        <section className="my-section my-demo-section" id="demo">
          <div className="my-shell">
            <SectionHeading
              eyebrow="Demo Etikaf TV"
              title="Lihat bagaimana maklumat berjalan di TV masjid."
              description="Paparan bergerak secara automatik dan boleh dikemas kini daripada Sistem Admin."
              align="center"
            />
            <div className="my-demo-frame">
              <div className="my-demo-top"><i /><i /><i /><span>Demo paparan ETV</span></div>
              <LazyDemoVideo />
            </div>
            <div className="my-feature-chips">
              {displayFeatures.map((feature) => (
                <span key={feature}><FiCheckCircle /> {feature}</span>
              ))}
            </div>
          </div>
        </section>

        <section className="my-section my-shell" id="harga">
          <div className="my-pricing-layout">
            <div className="my-pricing-copy">
              <SectionHeading
                eyebrow="Harga yang jelas"
                title="Satu pakej. Tiada caj peranti berulang setiap tahun."
                description="Harga dipecahkan supaya pihak masjid tahu dengan tepat apa yang dibayar pada tahun pertama dan tahun berikutnya."
              />
              <div className="my-price-points">
                <div><FiCheckCircle /><span><strong>Peranti sekali bayar</strong>RM3,000 dan tidak perlu dibeli semula setiap tahun.</span></div>
                <div><FiRepeat /><span><strong>Pembaharuan tahunan</strong>RM600 setahun untuk Sistem Admin dan perkhidmatan Etikaf.</span></div>
                <div><FiTruck /><span><strong>Penghantaran melalui pos</strong>RM25 Semenanjung · RM50 Sabah, Sarawak &amp; Labuan.</span></div>
                <div><FiShield /><span><strong>Waranti peranti</strong>Perlindungan selama 12 bulan.</span></div>
              </div>
            </div>

            <div className="my-pricing-card">
              <div className="my-pricing-badge">Pakej Etikaf</div>
              <p>Tahun pertama</p>
              <div className="my-price-main"><sup>RM</sup>3,600</div>
              <span className="my-price-shipping">+ RM25 Semenanjung / RM50 Malaysia Timur</span>
              <div className="my-price-breakdown">
                <div><span>Peranti Etikaf TV</span><strong>RM3,000</strong></div>
                <div><span>Sistem Etikaf — 1 tahun</span><strong>RM600</strong></div>
              </div>
              <ul>
                <li><FiCheck /> Peranti plug and play</li>
                <li><FiCheck /> Sistem Admin masjid</li>
                <li><FiCheck /> Halaman & QR masjid</li>
                <li><FiCheck /> PDF Takwim A4 automatik</li>
                <li><FiCheck /> Kuliah berulang, Asatizah & Kitab</li>
                <li><FiCheck /> Aplikasi Etikaf percuma untuk jemaah</li>
                <li><FiCheck /> Waranti peranti 12 bulan</li>
              </ul>
              <a className="my-button my-button-primary my-button-full" href={REGISTER_URL}>
                Mula pendaftaran <FiArrowRight />
              </a>
              <small className="my-payment-note">
                Satu pendaftaran dan satu bayaran: RM3,625 ke Semenanjung atau RM3,650 ke Sabah, Sarawak dan Labuan.
              </small>
            </div>
          </div>
        </section>

        <section className="my-section my-process-section">
          <div className="my-shell">
            <SectionHeading
              eyebrow="Daripada daftar hingga digunakan"
              title="Proses yang jelas untuk pihak masjid."
              description="Pendaftaran dan pembayaran bermula secara dalam talian melalui Sistem Admin Etikaf."
              align="center"
            />
            <div className="my-process-grid">
              <article><span>1</span><FiUsers /><h3>Daftar &amp; sahkan e-mel</h3><p>Cipta akaun rasmi masjid atau surau dan sahkan pemilikan e-mel.</p></article>
              <article><span>2</span><FiPackage /><h3>Isi penghantaran</h3><p>Masukkan maklumat pegawai dan alamat untuk menerima peranti ETV.</p></article>
              <article><span>3</span><FiCreditCard /><h3>Semak &amp; bayar</h3><p>Lihat jumlah lengkap termasuk penghantaran, kemudian bayar melalui Billplz.</p></article>
              <article><span>4</span><FiTruck /><h3>Peranti dipos</h3><p>Akaun Admin diaktifkan dan pesanan peranti diproses selepas bayaran disahkan.</p></article>
              <article><span>5</span><FiZap /><h3>Sambung &amp; guna</h3><p>Pasang secara plug and play dan mula urus seluruh ekosistem Etikaf.</p></article>
            </div>
            <div className="my-process-action">
              <a className="my-button my-button-primary" href={REGISTER_URL}>
                Daftar dan buat bayaran <FiArrowRight />
              </a>
              <a className="my-text-link" href={LOGIN_URL}>Sudah mempunyai akaun? Log masuk</a>
            </div>
          </div>
        </section>

        <section className="my-section my-shell" id="faq">
          <SectionHeading
            eyebrow="Soalan lazim"
            title="Semua yang perlu diketahui sebelum mendaftar."
            description="Klik soalan di bawah untuk melihat jawapan. Jika jawapan anda ada di sini, anda boleh terus mendaftar tanpa menunggu balasan mesej."
            align="center"
          />
          <div className="my-faq-layout">
            {faqGroups.map((group) => (
              <section className="my-faq-group" key={group.title}>
                <h3>{group.title}</h3>
                {group.items.map((item) => (
                  <details key={item.q}>
                    <summary>{item.q}<span>+</span></summary>
                    <p>{item.a}</p>
                  </details>
                ))}
              </section>
            ))}
          </div>
        </section>

        <section className="my-final-cta">
          <div className="my-shell my-final-cta-inner">
            <div>
              <span>Untuk Masjid &amp; Surau</span>
              <h2>Bersedia untuk jadikan maklumat masjid lebih tersusun?</h2>
              <p>Daftar dalam talian, aktifkan Sistem Admin dan teruskan pembelian peranti ETV melalui akaun masjid anda.</p>
            </div>
            <div className="my-final-actions">
              <a className="my-button my-button-light" href={REGISTER_URL}>
                Daftar Etikaf <FiArrowRight />
              </a>
              <a className="my-login-link" href={LOGIN_URL}>Log masuk Admin</a>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}
